var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view schedule"},[_c('v-container',{staticClass:"mt-15",style:('width: 100%; position: relative;')})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }